module.exports = __webpack_public_path__ + "static/media/headerimage.e858418a.jpg";